<template>
	<div class="assessSuccess">
		<nav-bar title="问题反馈" text="问题反馈" @onClickRight="onClickRight"></nav-bar>
		<van-list >
			<div v-for="(item,i) in list" :key="i" style="margin-top: 20px;" @click="finishedtioa(item.id)">
				<van-cell title-class="title" value-class="value" title="问题类型" is-link :value="item.questionType" />
				<van-cell title-class="title" value-class="value" title="订单编号" is-link :value="item.orderSn" />
				<van-cell title-class="title" value-class="value" title="反馈时间" is-link :value="item.addTime" />
			</div>
		</van-list>
		<!-- <div class="assess-wt" @click="backlist()">
      
    </div>
    <div class="assess-wt">
      <van-cell
        title-class="title"
        value-class="value"
        title="问题类型"
        is-link
        value="开始订单"
      />
      <van-cell
        title-class="title"
        value-class="value"
        title="反馈时间"
        is-link
        value="2019/12/20 9:50"
      />
    </div> -->
	</div>
</template>

<script>
	import NavBar from "@/components/navBar";
	import {
		Cell,
		List
	} from "vant";
	export default {
		name: "problemfeedbacklist",
		data() {
			return {
				list: [],
				// loading: false,
				// finished: false

			};
		},
		created() {
			this.feedback()
		},
		methods: {
			feedback() {
				this.$axios({
					url: "/vedm/accountCommonApp/getAccountEvaluation/"+localStorage.getItem('accountUid'),
					method: "get",
					headers: {
						Authorization: localStorage.getItem('token') //token换成从缓存获取
					},
				}).then(res => {
					this.list = res.data.data
				})

			},
			finishedtioa(id) {
				//console.log(id,"22233")
				this.$router.push({path:"/questionfeedbackdetails/"+id})  
			},

			onClickRight() {
				this.$router.push({
					name: "problemfeedback"
				});
			},
			
		},
		components: {
			NavBar,
			"van-cell": Cell,
			"van-list": List,
		}
	};
</script>

<style scoped lang="less">
	.assessSuccess {
		background: rgba(247, 247, 247, 1);

		.assess-wt {
			margin-top: 10px;
		}

		.project {
			align-items: center;

			.number {
				display: block;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(158, 160, 165, 1);
			}

			.name {
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: rgba(33, 37, 41, 1);
				margin: 0;
			}

			.tag {
				margin-left: 10px;
			}

			.tagRight {
				background: rgba(255, 149, 0, 0.1);
				border-radius: 2px;
				border: 1px solid rgba(255, 149, 0, 1);
				font-size: 11px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(255, 149, 0, 1);
				margin-right: 5px;
			}

			.spanRight {
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 37, 41, 1);
			}
		}

		.happening {
			width: 375px;
			background: rgba(255, 255, 255, 1);
			padding: 15px;
			margin-bottom: 12px;

			p {
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 37, 41, 1);
				margin: 0;
				margin-bottom: 20px;
			}

			.div {
				width: 104px;
				height: 28px;
				line-height: 28px;
				text-align: center;
				border-radius: 14px;
				border: 1px solid rgba(232, 233, 235, 1);
				margin: 0 auto;
				font-size: 14px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(33, 37, 41, 1);
			}

			.options {
				width: 345px;
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;
				margin-top: 24px;
			}

			.item {
				height: 28px;
				line-height: 28px;
				text-align: center;
				border-radius: 6px;
				padding: 0 20px;
				border: 1px solid rgba(232, 233, 235, 1);
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(98, 104, 112, 1);
			}
		}
	}
</style>
